<template>
  <div>
    <div v-if="show" :class="cssClass" role="alert">
      <slot></slot>
      <button
        v-if="dismissible"
        type="button"
        class="close"
        data-dismiss="alert"
        aria-label="Close"
        @click="$emit('close')"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BsNotification',
  props: {
    dismissible: {
      type: Boolean,
      default: false
    },
    show: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      default: 'danger',
      validator: function (value) {
        return [
          'primary',
          'secondary',
          'success',
          'info',
          'warning',
          'danger',
          'light',
          'dark'
        ].includes(value)
      }
    }
  },
  emits: ['close'],
  computed: {
    cssClass() {
      if (this.dismissible) {
        return 'alert alert-outline alert-' + this.type + ' alert-dismissible fade show'
      }
      return 'alert alert-outline alert-' + this.type
    }
  }
}
</script>
